// import Vue from 'vue'
// import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Vue.use(Vuex);

const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        loginInfo: '',
        isCollapse:document.body.clientWidth < 1200 ?true :false,
        newWorkorder:[],
        Refresh: false,
        RefreshVal: '',
        isLoading: false,
        userEmail:'',
        create:{},
        createCurrent:0,
        createNotifyShow:false,
        horizontalMenu:[],
        costMenu:{},
        workorderMenu:{},
        usercenterMenu:{},
        renewMenu:{},
        customerAuthCode:'3232132321',
    },
    mutations: {
        updateLoadingStatus (state, payload) {
          state.isLoading = payload.isLoading
        },
        updateCreateStatus (state,obj) {
            state.create = obj
        },
        updateCreateCurrentStatus (state,obj) {
            state.createCurrent = obj
        },
        updateCreateNotifyShow (state,obj) {
            state.createNotifyShow = obj
        },
        updateRefresh (state) {
            state.Refresh = !state.Refresh
        },
        updateNewWorkorder (state,obj) {
            state.newWorkorder = obj
        },
        addNewWorkorder (state,obj) {
            let index = _.findIndex(state.newWorkorder, function(o) { return o == obj })
            if(index<0){
                state.newWorkorder.push(obj)
            }
        },
        updateHorizontalMenu (state, array) {
          state.horizontalMenu = array
        },
        updateCostMenu (state, obj) {
          state.costMenu = obj
        },
        updateWorkorderMenuMenu (state, obj) {
          state.workorderMenu = obj
        },
        updateUsercenterMenu (state, obj) {
          state.usercenterMenu = obj
        },
        updateRenewMenu (state, obj) {
          state.renewMenu = obj
        },
        updateCustomerAuthCode (state, obj) {
          state.customerAuthCode = obj
        },
    },
    actions: {
        Refresh(context,val){
            context.state.Refresh = val
            // setTimeout(() => {
            //     context.state.Refresh = ''
            // },1000)
            
        },
        RefreshVal(context,val){
            context.state.RefreshVal = val
            // setTimeout(() => {
            //     context.state.Refresh = ''
            // },1000)
            
        }
    },

})


export default store



// WEBPACK FOOTER //
// ./src/store/store.js